import { Role, Space } from "types/generated";

import { GetEntitiesWithRoleBindingsData } from "./gql";
import { EntityType, EntityWithRoleBinding } from "./types";

export const getEntities = (
  data: GetEntitiesWithRoleBindingsData | undefined,
  spaces: Space[],
  role: Role
) => {
  return [
    ...(data?.managedUsers?.reduce<EntityWithRoleBinding[]>((acc, user) => {
      const roleBinding = user.userRoleBindings.find((binding) => binding.roleID === role.id);

      if (!roleBinding) {
        return acc;
      }

      const space = spaces.find((space) => space.id === roleBinding.spaceID);

      if (!space) {
        return acc;
      }

      return [
        ...acc,
        {
          type: EntityType.User,
          id: user.id,
          name: user.username,
          roleBindingId: roleBinding.id,
          space: {
            id: space.id,
            name: space.name,
          },
          isLastRole: user.userRoleBindings.length === 1,
        },
      ];
    }, []) || []),
    ...(data?.managedUserGroups?.reduce<EntityWithRoleBinding[]>((acc, userGroup) => {
      const roleBinding = userGroup.userRoleBindings.find((binding) => binding.roleID === role.id);

      if (!roleBinding) {
        return acc;
      }

      const space = spaces.find((space) => space.id === roleBinding.spaceID);

      if (!space) {
        return acc;
      }

      return [
        ...acc,
        {
          type: EntityType.UserGroup,
          id: userGroup.id,
          name: userGroup.groupName,
          roleBindingId: roleBinding.id,
          space: {
            id: space.id,
            name: space.name,
          },
          isLastRole: userGroup.userRoleBindings.length === 1,
        },
      ];
    }, []) || []),
    ...(data?.apiKeys?.reduce<EntityWithRoleBinding[]>((acc, apiKey) => {
      const roleBinding = apiKey.apiKeyRoleBindings.find((binding) => binding.role.id === role.id);

      if (!roleBinding) {
        return acc;
      }

      const space = spaces.find((space) => space.id === roleBinding.spaceID);

      if (!space) {
        return acc;
      }

      return [
        ...acc,
        {
          type: EntityType.ApiKey,
          id: apiKey.id,
          name: apiKey.name,
          roleBindingId: roleBinding.id,
          space: {
            id: space.id,
            name: space.name,
          },
          isLastRole: apiKey.apiKeyRoleBindings.length === 1,
        },
      ];
    }, []) || []),
  ];
};
